import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl, priceLabel, priceValue } from '../data/content';
import { trackInitiateCheckout } from '../hooks/useMetaPixel';
export function MobileCtaBar() {
  return <div className="fixed inset-x-0 bottom-0 z-50 border-t border-navy-700 bg-navy-900/95 px-4 py-3 backdrop-blur lg:hidden" data-id="element-144" data-mp="1t1jymigr8lqi">
      <div className="flex items-center gap-3" data-id="element-145" data-mp="1xx90wtk5sgqi">
        <div className="shrink-0" data-id="element-146" data-mp="119vnu0dmk79s">
          <p className="font-display text-xl font-extrabold leading-none tracking-[-0.03em] text-gold" data-id="element-147" data-mp="11anhv6rkpwxy">
            {priceLabel}
          </p>
          <p className="mt-1 text-[10px] uppercase tracking-[0.12em] text-steel" data-id="element-148" data-mp="1aa0x6g2dpfql">Today only</p>
        </div>
        <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout(priceValue)} className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-gold px-4 py-3.5 font-display text-sm font-extrabold uppercase tracking-[0.03em] text-navy transition-colors duration-150 ease-smooth hover:bg-gold-bright focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-bright" data-id="element-149" data-mp="1f10s5frxtnqg">
          Get the system
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" strokeWidth={2.5} data-id="element-150" data-mp="36fvscxmxlr5l" />
        </a>
      </div>
    </div>;
}